// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__9_AUc","right":"Footer_right__1_rBl","buttons":"Footer_buttons__1Wnpy"};